__turbopack_context__.v({
  "container": "_80lha_container",
  "title": "_80lha_title",
});
